import React from "react";
import { ThemeProvider } from "styled-components";

import theme from "js/themes/theme";

// providers

// components
import { LegacySiteFooter } from "core/SiteFooter";

export const NounProjectFooter = () => {
    return (
        <ThemeProvider theme={theme}>
            <LegacySiteFooter />
        </ThemeProvider>
    );
};

export default NounProjectFooter;
